import { FormProvider, useForm } from 'react-hook-form';
import { memo, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { DSTextField } from '@demandstar/components/fields';
import Configurations from '../../../settings';
import  EunaOpenBidLogo from '../../../assets/images/EunaOpenBidsLogo.svg';


import { dismisstoastAllFn, isValidRequiredTrimmingSpace, toastFn } from '../../../utils/helpers';
import { MemberType, Pages, Paths } from '../../../utils/constants';
import { ErrorPanel } from '../loading';
import { Permission } from '../../../types/auth';
import { useRouter } from 'src/shared/hooks';
import { useAuthContext } from 'src/auth/AuthProvider';
import useScreenWidth from '@demandstar/components/utils/screenSizeListener';

// function Login({ login }: PropsFromRedux) {
export function Login() {
  const methods = useForm({
    defaultValues: {
      userName: '',
      password: '',
    },
  });
  const {  getValues, handleSubmit } = methods;
  const { auth, handleLogin, hasError, loginError } = useAuthContext();
  const { history } = useRouter();
  const isMobileView = useScreenWidth(1235);

  useEffect(() => {
    const isExpired = sessionStorage.getItem('isloggingout');
    if (isExpired === '1') {
      toastFn('error', 'Session expired', 'Session expired');
    }
    sessionStorage.removeItem('isloggingout');
  }, []);

  useEffect(() => {
    dismisstoastAllFn();
  }, []);

  useEffect(() => {
    if (auth?.memberType) {
      const path =
        auth?.memberType === MemberType.AgencyBuyer
          ? Pages.buyerDashboard
          : Pages.supplierDashboard;
      history.replace(path);
    } else if (auth && auth.accountId > 0 && auth?.accountPermissions.includes(Permission.Ops)) {
      history.replace(Paths.ops.agencyRegistration);
    }
  }, [auth, history]);

  useEffect(() => {
    document.body.className = '';
    document.body.classList.add('light_DS');
  }, []);

  const handleLoginSubmit = async () => {
    const userName = getValues('userName');
    const password = getValues('password');
    if (userName && password) {
      try {
        const loginRsponse = await handleLogin({ userName, password });
      } catch (error) {
        console.log('src/components/common/login/login.tsx - handleLoginSubmit(): error', error);
      }
    }
  };

  const GoHome = () => {
    window.location.href = Configurations.REACT_APP_REDIRECT_HOME_URL;
  };

  return (
    <form onSubmit={handleSubmit(handleLoginSubmit)}>
      <h1  className='row d-flex justify-content-center align-items-center'>logout Bug check</h1>
      <div className='container loginWrapper'>
        <div
          className='row d-flex justify-content-center align-items-center'
          style={{ height: '100vh' }}
        >
          <div className='col-10 col-md-5'>
            <span onClick={GoHome}>
              {/* <LogoDS /> */}
           <div className="d-flex justify-content-center align-items-center ">
  <img src={EunaOpenBidLogo} alt="Euna Open Bid Logo" className="img-fluid w-50"/>
</div>


            </span>
            <FormProvider {...methods}>
              <DSTextField
                label='Username'
                name='userName'
                rules={{ validate: isValidRequiredTrimmingSpace }}
              />
              <DSTextField label='Password' name='password' type='password' />
            </FormProvider>

            {/* {authError && <ErrorPanel message={authMessaging.loginError} />} */}
            {hasError && <ErrorPanel message={loginError} />}

            <Link className='needHelp' to={'/accountrecovery'}>
              Need help logging in?
            </Link>
            <br></br>
            <span>
              If you are a new government agency,{' '}
              <a href='https://network.demandstar.com/schedule-a-demo/'>sign up here</a>.
            </span>
            {!isMobileView ?
            <div className='container action-buttons mt-3'>
              <div className='row'>
                <div className='col'>
                  <Link className='bttn bttn-secondary m-auto d-block' to={'/registration'}>
                    Sign Up
                  </Link>
                </div>
                <div className='col'>
                  <button className='bttn bttn-primary m-auto d-block' name='login' type='submit'>
                    Login
                  </button>
                </div>
              </div>
            </div>
            :
            <div className='container action-buttons mt-3'>
            <div className='row'>
              <div className='col'>
                <button className='bttn bttn-primary m-auto d-block' name='login' type='submit'>
                  Login
                </button>
              </div>
              <div className='col'>
                <Link className='bttn bttn-secondary m-auto d-block' to={'/registration'}>
                  Sign Up
                </Link>
              </div>
            </div>
          </div>}
          </div>
        </div>
      </div>
    </form>
  );
}

// const connector = connect(
//   state => state,
//   dispatch => bindActionCreators({ ...actionCreators }, dispatch),
// );
// type PropsFromRedux = ConnectedProps<typeof connector>;

// export default connector(memo(Login));
